import React from 'react';
import { Typography, useTheme } from '@mui/material';

const DSHeaderTypography = (props: React.ComponentProps<typeof Typography>) => {
  const { palette } = useTheme();
  return <Typography variant="h5" color={palette.text.primary} {...props} />;
};

export default DSHeaderTypography;
